import React, { useEffect, useState } from 'react';
import Banner from '../components/Banner';
import Categories from '../components/Categories';
import MenuItems from '../components/MenuItems';
import CartSummary from '../components/CartSummary';
import Footer from '../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentLoginInformation,
  getCurrentTenantDisplayInfo,
  getCurrentUser,
} from '../redux/auth/authSlice';

// Hook Import
import { useThemeColors } from '../hooks/useThemeColors';
// import { getAvailableUserAddress } from '../redux/pos/posSlice';
import CartForResponsive from '../components/CartForResponsive';

const Home = ({ onOrderSelect, orderType }) => {
  const currentTenant = useSelector(getCurrentTenantDisplayInfo);
  const user = useSelector(getCurrentUser);
  // const userAddress = useSelector(getAvailableUserAddress);
  const dispatch = useDispatch();

  const { themeBg, textColor, isDark } = useThemeColors();

  const [showBucketDetails, setShowBucketDetails] = useState(false);
  const [emptyButton, setEmptyButton] = useState(false);

  useEffect(() => {
    dispatch(getCurrentLoginInformation());
  }, [dispatch]);

  // useEffect(() => {
  //   if (user?.referenceId) {
  //     dispatch(getUserAddress({ userId: user.referenceId }));
  //   }
  // }, [dispatch, user?.referenceId]);

  useEffect(() => {
    if (currentTenant) {
      window.document.title = `${currentTenant.name}`;
    }
  }, [currentTenant]);

  // Address list check
  // const addressList = Array.isArray(userAddress)
  //   ? userAddress
  //   : userAddress?.items || [];

  // console.log('My Addresses from API:', addressList);

  return (
    <div
      className="home-wrapper mt-0 p-0"
      style={{
        backgroundColor: themeBg,
        color: textColor,
        minHeight: '100vh',
        transition: 'all 0.3s ease',
      }}
    >
      {!showBucketDetails && <Banner />}

      <div className="container p-sm-0">
        {/* ADDRESS UI YAHAN SE HATA DIYA GAYA HAI */}

        {!showBucketDetails && <Categories darkMode={isDark} />}

        <div className="menu-container row p-2 p-sm-0 mx-0 gy-2">
          <div className="col-lg-8 p-0">
            <MenuItems
              onOrderSelect={onOrderSelect}
              orderType={orderType}
              showBucketDetails={showBucketDetails}
              setShowBucketDetails={setShowBucketDetails}
              darkMode={isDark}
            />
          </div>
          <div className="col-lg-4 p-0 d-none d-lg-block">
            <div className="ps-lg-2">
              <CartSummary
                showBucketDetails={showBucketDetails}
                setShowBucketDetails={setShowBucketDetails}
                emptyButton={emptyButton}
                darkMode={isDark}
              />
            </div>
          </div>
        </div>
      </div>
      <CartForResponsive />
      {!showBucketDetails && <Footer darkMode={isDark} />}
    </div>
  );
};

export default Home;
